module.exports = __webpack_public_path__ + "img/69_19.ee6eb422.png";